// ============================================
// App Module - Navigation Functions (ES6)
// ============================================

import { getCurrentUser } from './state.js';
import { showLoginModal, updateCarbonDisplay } from '../auth/index.js';

// ============================================
// 탭 상태
// ============================================

let currentTab = 'home';

export function getCurrentTab() {
  return currentTab;
}

export function setCurrentTab(tab) {
  currentTab = tab;
}

// ============================================
// 탭 전환
// ============================================

export function switchTab(tabName) {
  // 로그인 필요한 탭 체크 (내 채팅, 내 작품, 마이페이지)
  if ((tabName === 'chats' || tabName === 'myWorks' || tabName === 'myPage') && !getCurrentUser()) {
    showLoginModal();
    return;
  }

  // 탭 전환 시 열린 모달 모두 닫기
  if (window.ModalManager) {
    window.ModalManager.closeAll();
  }

  currentTab = tabName;

  // Hide all tabs
  document.querySelectorAll('.tab-content').forEach(tab => {
    tab.classList.remove('active');
  });

  // Show selected tab
  const tabEl = document.getElementById(tabName + 'Tab');
  if (tabEl) {
    tabEl.classList.add('active');
  }

  // Update nav items
  document.querySelectorAll('.nav-item').forEach(item => {
    item.classList.remove('active');
    if (item.dataset.tab === tabName) {
      item.classList.add('active');
    }
  });

  // Update carbon displays
  updateCarbonDisplay();

  // Load content for specific tabs
  if (tabName === 'home') {
    if (typeof window.loadHomeContent === 'function') {
      window.loadHomeContent();
    }
  } else if (tabName === 'myPage') {
    if (typeof window.loadMyPageContent === 'function') {
      window.loadMyPageContent();
    }
  } else if (tabName === 'myWorks') {
    // Creator 탭 데이터 로드
    if (typeof window.CreatorModule !== 'undefined') {
      window.CreatorModule.loadCreations('all');
    }
  }
}

// ============================================
// 네비게이션 가시성 업데이트 (어드민 전용 탭)
// ============================================

export function updateNavVisibility(isAdmin) {
  const myWorksTab = document.querySelector('.nav-item[data-tab="myWorks"]');
  if (myWorksTab) {
    if (isAdmin) {
      myWorksTab.classList.add('admin-visible');
    } else {
      myWorksTab.classList.remove('admin-visible');
    }
  }
}

// ============================================
// 이벤트 리스너 초기화
// ============================================

export function initNavigationEvents() {
  // 네비게이션 버튼 이벤트 리스너
  document.querySelectorAll('.nav-item[data-tab]').forEach(btn => {
    btn.addEventListener('click', () => {
      const tab = btn.dataset.tab;
      if (tab) switchTab(tab);
    });
  });

  console.log('[Navigation] 이벤트 리스너 초기화 완료');
}

// 모듈 초기화
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNavigationEvents);
} else {
  initNavigationEvents();
}

// ============================================
// 필수 window 노출 (다른 모듈에서 호출)
// ============================================
// detail.js 등에서 탭 전환 시 호출
window.switchTab = switchTab;
